import Page from '../../../src/client/pages/offers/terms-and-conditions';

// @ts-expect-error - Automatic, Please fix when editing this file
export async function getServerSideProps({ query }) {
  return {
    props: {
      match: {
        params: {
          offerId: query.slug,
        },
      },
    },
  };
}

export default Page;
